import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import LinkedInSearchPage from "../../pages/LinkedInSearchPage";
import UsagePage from "../../pages/UsagePage";
import AdminReviewView from "../Admin/AdminReviewView";
import AdminUsagePage from "../Admin/AdminUsagePage";
import DataIntegrationsView from "../DataIntegrations/DataIntegrationsView";
import { AllDealsPage } from "../Deals/AllDealsPage";
import { DealsFollowupPage } from "../Deals/DealsFollowupPage";
import { HotDealsPage } from "../Deals/HotDealsPage";
import Layout from "../Layout/Layout";
import ListsContainer from "../Lists/ListsContainer";
// Target Markets is disabled — see docs/feature-disabling-audit.md.
// NOTE: components/TargetMarkets/LinkedInFilterPanel is NOT part of that feature; it is the
// live filter UI used by LinkedInSearchPage. Only TargetMarketsView is switched off here.
// import TargetMarketsView from "../TargetMarkets/TargetMarketsView";
// Route to tab index mapping
const routeToTab = {
    "/search": 0,
    "/contacts": 1,
    // "/target-markets": 2,  // disabled
    "/data-integrations": 3,
    "/admin": 4,
    "/admin/deals": 5,
    "/usage": 6,
    "/admin/usage": 7,
    "/admin/deals/all": 8,
    "/admin/deals/hot": 9,
};
const Dashboard = () => {
    const location = useLocation();
    // Get active tab from URL
    const getActiveTab = () => {
        const path = location.pathname;
        // Check for exact match first
        if (routeToTab[path] !== undefined) {
            return routeToTab[path];
        }
        // Check for data-integrations sub-routes
        if (path.startsWith("/data-integrations")) {
            return 3;
        }
        // Check for admin sub-routes
        if (path.startsWith("/admin")) {
            return 4;
        }
        return 0;
    };
    const activeTab = getActiveTab();
    return (_jsx(Layout, Object.assign({ activeTab: activeTab }, { children: _jsxs(Box, Object.assign({ sx: { height: "100%" } }, { children: [activeTab === 0 && _jsx(LinkedInSearchPage, {}), activeTab === 1 && _jsx(ListsContainer, {}), activeTab === 3 && _jsx(DataIntegrationsView, {}), activeTab === 4 && _jsx(AdminReviewView, {}), activeTab === 5 && _jsx(DealsFollowupPage, {}), activeTab === 6 && _jsx(UsagePage, {}), activeTab === 7 && _jsx(AdminUsagePage, {}), activeTab === 8 && _jsx(AllDealsPage, {}), activeTab === 9 && _jsx(HotDealsPage, {})] })) })));
};
export default Dashboard;
